import type { StatsParams } from "../types";
import { useFetchKpis } from "./useFetchKpis";

/**
 * Global completion rate lives on the `/stats/kpis/` payload — reuse the KPIs
 * query (same key) and select the `global_completion_rate` field so both share
 * a single request.
 */
export function useGlobalCompletionRate({ start_date, end_date }: StatsParams) {
  const { data, isLoading, isFetching, error } = useFetchKpis({
    start_date,
    end_date,
  });

  return {
    data: data?.global_completion_rate,
    isLoading,
    isFetching,
    error,
  };
}
